export const commonApi = {
  getConfig: ({ appSecret }) => ({ url: 'v2/:clientId/get-config', method: 'get', params: { appSecret }, isPublic: true }),
  getLayoutConfig: ({ appSecret }) => ({ url: 'v2/:clientId/get-quick-layout', method: 'get', params: { appSecret }, isPublic: true }),
  feeds: ({ appSecret }) => ({ url: 'v2/:clientId/feeds', method: 'get', params: { appSecret }, isPublic: true }),
  broadcast: ({ appSecret } = {}) => ({ url: 'v2/:clientId/broadcast', method: 'get', params: { appSecret }, isPublic: true }),
  getAnnouncements: ({ appSecret }) => ({ url: 'v2/:clientId/get-announcements', params: { appSecret }, method: 'get', isPublic: true }),
  getNavbar: ({ appSecret } = {}) => ({ url: 'v2/:clientId/get-navbar-setting', params: { appSecret }, method: 'get', isPublic: true }),
  getDefaultAffiliateCode: ({ appSecret }) => ({ url: 'v2/:clientId/get-affiliate-code', params: { appSecret }, method: 'get', isPublic: true }),
  getSiteInfoConfig: ({ appSecret, config }) => ({
    url: 'v2/:clientId/get-site-config',
    method: 'get',
    params: { appSecret, config },
    isPublic: true,
  }),
  sendPixel: ({ appSecret, eventId, fbc, fbp, event, eventSourceUrl }) => ({
    url: 'v2/:clientId/pixel',
    method: 'post',
    params: { appSecret, eventId, fbc, fbp, event, eventSourceUrl },
  }),
}
